import communication from "./communication";
import dashboard from "./dashboard";
import financial from "./financial";
import genealogy from "./genealogy";
import members from "./members";
import reports from "./reports";
import settings from "./settings";
import statistics from "./statistics";
import store from "./store";
import subAdmin from "./subAdmin";
import subscriptions from "./subscriptions";
import tools from "./tools";
import user from "./user";
import packages from "./packages";
import course from "./course";
import invoice from "./invoice";

const routes = [
  ...communication,
  ...dashboard,
  ...financial,
  ...genealogy,
  ...members,
  ...reports,
  ...settings,
  ...statistics,
  ...store,
  ...subAdmin,
  ...subscriptions,
  ...tools,
  ...user,
  ...packages,
  ...course,
  ...invoice,
];

export default routes;
